import { UserDataService } from './../../data-services/user-data.service';
import { Injectable } from '@angular/core';
import {
  FormBase,
  TextBox,
  GetGooglePlaceService,
} from '@mapfre-design-library/src/public_api';
import { AddressInputService } from '../change-address/change-address.service';
import { map } from 'rxjs/operators';
import { Constants } from '@models/constants';

@Injectable()
export class CheckingAccountService {
  checkingAccount: any;
  userDetails: any;

  constructor(
    private changeAddressService: AddressInputService,
    private userDataService: UserDataService,
    private getGooglePlaceService: GetGooglePlaceService
  ) {}

  getInputs(policyId) {
    return this.userDataService.$userData.pipe(
      map((userResponse) => {
        const checkingInfo = userResponse.bankAccountDetails.filter(
          (x) => x.policyNumber === policyId
        );
        this.checkingAccount =
          checkingInfo && checkingInfo.length > 0 ? checkingInfo[0] : {};
        this.userDetails = userResponse.userDetails;
        if (this.userDetails.middleName) {
          this.userDetails.middleName =
            this.userDetails.middleName === 'DEFAULT'
              ? ''
              : this.userDetails.middleName;
        }
        if (this.userDetails.lastName) {
          this.userDetails.lastName =
            this.userDetails.lastName === 'DEFAULT'
              ? ''
              : this.userDetails.lastName;
        }

        if (!this.checkingAccount.mailingAddress) {
          this.checkingAccount.mailingAddress = {
            city: '',
            state: '',
            stateCode: '',
            streetName: '',
            zipCode: { code: '' },
          };
        }
        if (this.checkingAccount.accountHolderName) {
          this.checkingAccount.accountHolderName =
            this.checkingAccount.accountHolderName
              .replaceAll('DEFAULT', '')
              .trim();
          this.getGooglePlaceService.updateAddress(
            this.checkingAccount.mailingAddress
          );          
        }

        const inputs: FormBase<any>[] = [
          new TextBox({
            additionalClasses: Constants.FORM_CONTROL,
            inputType: 'text',
            value: this.checkAccountDetails(this.checkingAccount)
              ? `${this.userDetails.firstName} ${
                  this.userDetails.middleName &&
                  this.userDetails.middleName !== ''
                    ? this.userDetails.middleName + ' '
                    : ''
                }${
                  this.userDetails.lastName
                    ? this.userDetails.lastName + ' '
                    : ''
                }`.trim()
              : this.checkingAccount.accountHolderName,
            key: 'bankAccountHolder',
            label: 'BANK_ACCOUNT_HOLDERS_NAME',
            required: true,
            type: 'text',
            validationMessageError: 'BANK_ACCOUNT_HOLDER_NAME_VALIDATION',
          }),
          new TextBox({
            additionalClasses: Constants.FORM_CONTROL,
            inputType: 'bank',
            key: 'bankAccountRoutingNumber',
            label: 'BANK_ROUTING_NUMBER',
            maxLength: 9,
            minLength: 9,
            required: true,
            type: 'tel',
            validationMessageError: 'BANK_ROUTING_NUMBER_VALIDATION',
          }),
          new TextBox({
            additionalClasses: Constants.FORM_CONTROL,
            inputType: 'bank_account_number',
            key: 'bankAccountNumber',
            label: 'BANK_ACCOUNT_NUMBER',
            maxLength: 17,
            minLength: 5,
            required: true,
            type: 'tel',
            validationMessageError: 'BANK_ACCOUNT_NUMBER_VALIDATION',
          }),
          new TextBox({
            additionalClasses: Constants.FORM_CONTROL,
            inputType: 'bank_account_number',
            key: 'confirmBankAccountNumber',
            label: 'CONFIRM_BANK_ACCOUNT_NUMBER',
            required: true,
            type: 'tel',
            maxLength: 17,
            minLength: 5,
            validationMessageError: 'BANK_ACCOUNT_NUMBER_VALIDATION',
          }),
          ...this.changeAddressService.getInputs(
            'checking-account-address',
            '',
            '',
            'MAILING_ADDRESS',
            policyId,
            'mailing'
          ),
        ];
        return inputs;
      })
    );
  }

  checkAccountDetails(accountDetails) {
    if (accountDetails.accountNumber && accountDetails.accountNumber.digits) {
      return false;
    } else {
      return accountDetails;
    }
  }
}
